export interface SalesOrderLineBillOfMaterials {
  productKey: string;
  productDescription: string;
  productTypeDescription: string;
  sequence: number;
  quantity: number;
  purchaseOrderLineId: string;
  purchaseOrderNumber: string;
  supplierKey: string;
  supplierName: string;
  status: string;
  statusDate: Date;
  deliveryDate: Date;
}
